import { render, staticRenderFns } from "./StepperEtapas.vue?vue&type=template&id=237e5c9b"
import script from "./StepperEtapas.vue?vue&type=script&lang=js"
export * from "./StepperEtapas.vue?vue&type=script&lang=js"
import style0 from "./StepperEtapas.vue?vue&type=style&index=0&id=237e5c9b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports